/**
 * http://confluence.mockuai.com/display/wdzgxcx/module_property%23title
 */
let config = [{
        key: "tips",
        value: "红包链接可以拖拽改变顺序",
        type: "tips"
    },
    {
        name: "红包",
        type: "module-name"
    },
    {
        key: "link_data",
        name: "链接",
        type: "red-packets"
    }
];
export default config;